// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--v8Wme","logo":"_02712f2b3b--logo--TN8gi","description":"_02712f2b3b--description--XHYiD"};